import moment from "moment/moment"

import { getStorage } from "./storage"

/**
 * 判断是否为移动端
 * @returns {string}
 */
const isMobile = () => {
    let isMobile = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    return isMobile ? 'WAP' : 'PC';
}

/**
 * 返回 innerWidth
 * @returns {number}
 */
const innerWidth = () => {
    return window.innerWidth
}

/**
 * 返回 innerHeight
 * @returns {number}
 */
const innerHeight = () => {
    return window.innerHeight
}

/**
 * 性别映射
 * @returns {[{label: string, value: string},{label: string, value: string},{label: string, value: string}]}
 */
const genderMap = () => {
    return [
        { value: 'male', label: '男' },
        { value: 'female', label: '女' },
        { value: 'secrecy', label: '保密' }
    ]
}

/**
 * 状态映射
 * @returns {[{label: string, value: string},{label: string, value: string},{label: string, value: string}]}
 */
const statusMap = () => {
    return [
        { value: 'normal', label: '正常' },
        { value: 'hidden', label: '关闭' }
    ]
}

/**
 * 客户状态映射
 * @returns {[{label: string, value: string},{label: string, value: string},{label: string, value: string}]}
 */
const clientStatusMap = () => {
    let map = [
        { value: 0, label: '草稿' },
        { value: 1, label: '待分配' },
        { value: 2, label: '待定' },
        { value: 3, label: '有效' },
        { value: 4, label: '无效-待确认' },
        { value: 5, label: '无效' }
    ]

    return isSuper() ? map : map.filter(item => {return [0, 1, 4].indexOf(item.value) === -1})
}

/**
 * 客户跟进状态映射，非公海
 * @returns {[{label: string, value: string},{label: string, value: string},{label: string, value: string}]}
 */
const clientFollowStatusMap = () => {
    return [
        { value: 0, label: '待跟进' },
        { value: 1, label: '跟进中' },
        { value: 2, label: '已完成' }
    ]
}

/**
 * 团队性质
 * @returns {[{label: string, value: number},{label: string, value: number},{label: string, value: number}]}
 */
const propertyMap = () => {
    return [
        { value: 1, label: '内部' },
        { value: 2, label: '代理' }
    ]
}

/**
 * 客户跟进状态映射，公海
 * @returns {[{label: string, value: string},{label: string, value: string},{label: string, value: string}]}
 */
const highseasMap = () => {
    let user = getStorage('user')
    let arr = []

    if (isSuper()) {
        arr.splice(1, 0, {label: '淘宝公海', value: 5})
        arr.splice(2, 0, {label: '内部公海', value: 3})
        arr.splice(3, 0, {label: '事业部公海', value: 4})
    } else {
        if (user.team.property === 1) {
            arr.splice(1, 0, {label: '内部公海', value: 3})
            arr.splice(2, 0, {label: '淘宝公海', value: 5})
        }

        if (user.team.id === 2 || user.team.id === 6 || user.team.id === 16) {
            arr.splice(2, 0, {label: '淘宝公海', value: 5})
        }
    }

    return arr
}

/**
 * 客户跟进状态映射，全部
 * @returns {[{label: string, value: string},{label: string, value: string},{label: string, value: string}]}
 */
const clientFollowStatusAllMap = () => {
    return [
        { value: 0, label: '待跟进' },
        { value: 1, label: '跟进中' },
        { value: 2, label: '已完成' },
        { value: 3, label: '内部公海' },
        { value: 4, label: '代理公海' },
        { value: 5, label: '淘宝公海' },
    ]
}

/**
 * 获取映射
 * @param value
 * @returns {string}
 */
const getMap = (value, mapStr) => {
    let mapArray
    switch (mapStr) {
        case 'gender' :
            mapArray = genderMap()
            break
        case 'clientStatus' :
            mapArray = clientStatusMap()
            break
        case 'clientFollowStatus' :
            mapArray = clientFollowStatusMap()
            break
        case 'highseas' :
            mapArray = highseasMap()
            break
        case 'clientFollowStatusAll' :
            mapArray = clientFollowStatusAllMap()
            break
        case 'status' :
            mapArray = statusMap()
            break
        case 'property' :
            mapArray = propertyMap()
            break
        default :
            mapArray = []
    }
    let map = mapArray.filter(item => {
        return item.value === value
    })
    return map.length > 0 ? map[0].label : '-'
}

/**
 * 权限检测
 * @param route
 * @returns {boolean}
 */
const checkPower = (route) => {
    let powers = getStorage('power')
    let power = powers.filter(item => {
        return 'api'+route === item.name
    })
    return power.length > 0
}

/**
 * 时间格式转换
 * @param time
 * @param format
 * @param isMoment
 * @returns {string|moment.Moment|string}
 */
const timeFormat = (time, format = 'YYYY-MM-DD HH:mm:ss', isMoment = false) => {
    if (time === 0 || time === null || time === undefined) {
        return ''
    }
    return isMoment ? moment(time * 1000) : moment(time * 1000).format(format)
}

/**
 * 获取时间间隔
 * @param startTime
 * @param endTime
 * @returns {string}
 */
const timeInterval = (startTime, endTime = new Date()) => {
    endTime = endTime.getTime()
    let usedTime = endTime - startTime // 相差的毫秒数
    let days = Math.floor(usedTime / (24 * 3600 * 1000)) // 计算出天数
    let leavel1 = usedTime % (24 * 3600 * 1000); // 计算天数后剩余的时间
    let hours = Math.floor(leavel1 / (3600 * 1000)) // 计算剩余的小时数
    let leavel2 = leavel1 % (3600 * 1000) // 计算剩余小时后剩余的毫秒数
    let minutes = Math.floor(leavel2 / (60 * 1000)) // 计算剩余的分钟数

    if (days === 0 && hours === 0) {
        return minutes + '分钟前'
    }
    if (days === 0 && hours !== 0) {
        return hours + '小时' + minutes + '分钟前'
    }

    if (days > 7) {
        return  timeFormat(startTime / 1000)
    }

    return days + '天' + hours + '小时' + minutes + '分钟前'
}

/**
 * 获取客户跟进分类
 * @param val
 * @returns {string}
 */
const getClientFollowCategory = (val) => {
    let str
    switch (val) {
        case 2:
            str = '修改资料'
            break
        case 5:
            str = '录入记录'
            break
        case 6:
            str = '外呼记录'
            break
        default :
            str = '系统录入'
    }
    return str
}

/**
 * 判断人员分组
 * @param groupArray
 * @param group
 * @returns {boolean}
 */
const userGroup = (groupArray, group) => {
    if (group === 0) {
        let user = getStorage('user')
        group = user.group
    }
    return groupArray.indexOf(group) !== -1
}

/**
 * 判断是否为超管
 * @param group
 * @returns {boolean}
 */
const isSuper = (group = 0) => {
    return userGroup([1], group)
}

/**
 * 判断是否为管理
 * @param group
 * @returns {boolean}
 */
const isLeader = (group = 0) => {
    return userGroup([2, 4, 6, 8], group)
}

/**
 * 判断是否为销售人员
 * @param group
 * @returns {boolean}
 */
const isSales = (group = 0) => {
    return userGroup([2, 3, 4, 5, 6, 7, 8, 9], group)
}

/**
 * 判断是否为代理
 * @param property
 * @returns {boolean}
 */
const isAgent = (property = 0) => {
    if (property === 0) {
        let user = getStorage('user')
        property = user.team ? user.team.property : 0
    }
    return property === 2
}

/**
 * 判断是否为推广人员
 * @param group
 * @returns {boolean}
 */
const isExpand = (group = 0) => {
    return userGroup([10], group)
}

/**
 * 判断是否为公海数据
 * @param followStatus
 * @returns {boolean}
 */
const isHigSeas = (followStatus) => {
    return [3, 4, 5].indexOf(followStatus) !== -1
}

/**
 * 获取 URL 参数
 * @param key
 * @param defautl
 * @returns {{}}
 */
const getQuery = (key = null, defautl = null) => {
    let query = {}

    let hash = window.location.hash
    let indexOf = hash.indexOf('?')
    if (indexOf !== -1) {
        let param = hash.substring(indexOf+1).split('&')
        param.forEach(item => {
            let itemArr = item.split('=')
            query[itemArr[0]] = itemArr[1]
        })
    }

    let result
    if (key === null) {
        result = query
    } else {
        if (query[key] === undefined ) {
            result = defautl !== null ? defautl : null
        } else {
            result = query[key]
        }
    }
    return result
}

const isFollow = (client) => {
    // 超管直接跟进
    if (isSuper()) {
        return true
    }

    let { share, status, follow_status, follow_user_id  } = client
    let user = getStorage('user')

    // 判断客户是否在共享数据中
    let isShare = false
    let shareLength = client.share.length
    if (shareLength !== 0) {
        for (let i=0; i<shareLength; i++) {
            if (share[i].user_id === user.id) {
                isShare = true
                break
            }
        }
    }
    return ([3, 5].indexOf(status) !== -1 && [0, 1, 2].indexOf(follow_status) !== -1)  && (follow_user_id === user.id || isShare)
}

const isShare = (client) => {
    // 超管直接跟进
    if (isSuper()) {
        return true
    }

    let { share, follow_status, follow_user_id, follow_num  } = client
    let user = getStorage('user')

    // 判断客户是否在共享数据中
    let isShare = false
    let shareLength = client.share.length
    if (shareLength !== 0) {
        for (let i=0; i<shareLength; i++) {
            if (share[i].user_id === user.id) {
                isShare = true
                break
            }
        }
    }
    return (follow_num > 0 && [0, 1, 2].indexOf(follow_status) !== -1)  && (follow_user_id === user.id || isShare)
}

export {
    isMobile, innerWidth, innerHeight, timeInterval, timeFormat, getQuery,
    genderMap, clientStatusMap, clientFollowStatusMap, getMap, getClientFollowCategory, highseasMap, statusMap, propertyMap,
    checkPower, isSuper, isLeader, isSales, isAgent, isExpand, isFollow, isShare, isHigSeas
}